import i18n from 'i18n'
import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'


const OPTIONS = [
    { label: 'Date range', value: 'range' },
    { label: 'Specific dates', value: 'specific' }
]

// Display-only: value ('range'/'specific') es la identidad; solo se traduce el texto.
const CAL_KEY = { range: 'common:filters.calendarRange', specific: 'common:filters.calendarSpecific' }

export default function SelectCalendarType({ ...props }) {
    const myProps = {
        placeholder: i18n.t('common:filters.calendarType'),
        formatOptionLabel: opt => i18n.t(CAL_KEY[opt?.value] || '', { defaultValue: opt?.label }),
        firstSelect: true,
        isClearable: false,
        options: OPTIONS,
        icon: { icon: 'calendar' },
        isMulti: false,
        ...props
    }

    return <SelectSeeker {...myProps} />
}